"use client";

import styled from "styled-components";

//Components
import { Button } from "../ui/button";

export const ButtonTable = styled(Button)`
  background: transparent;
  color: var(--textLight);
  transition: 0.3s;
  cursor: pointer;
  padding: 0px 10px;
  box-shadow: none;
  background: var(--muted);

  &:hover {
    color: var(--titleColor);
  }
`;
